import { cond, constant, gte, inRange, lt, partial, stubTrue } from 'lodash';

type Quality = 'low' | 'mid' | 'high' | 'lossless';

const pictureRegex = /picture2\.(\w*\.)?frame\.io\//;

const aSensibleMapOfNumericQualityToStringValue = cond<number, Quality>([
  [partial(lt, partial.placeholder, 33), constant('low')],
  [partial(inRange, partial.placeholder, 33, 75), constant('mid')],
  [partial(inRange, partial.placeholder, 75, 100), constant('high')],
  [partial(gte, partial.placeholder, 100), constant('lossless')],
  [stubTrue, constant('mid')],
]);

type LoaderArgs = {
  src: string;
  width: number;
  quality?: number;
};

export function imageLoader({ src, width, quality = 50 }: LoaderArgs) {
  if (!pictureRegex.test(src)) {
    throw Error(
      `only URLs for the picture2 service are supported. URL given ${src}`
    );
  }

  const url = new URL(src);
  const qualityParam = aSensibleMapOfNumericQualityToStringValue(quality);

  /**
   * @note Supported picture2 params https://github.com/Frameio/picture2/blob/main/openapi.yaml
   */
  url.searchParams.set('width', `${width}`);
  url.searchParams.set('quality', qualityParam);

  return url.toString();
}
